import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicMyInscriptions = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Vos inscriptions', link: '/topics/inscription'},
    { label: topic.title, link: topic.link},
  ];

  // <a target='_blank' className="link" href="https://wodzone.fr">https://wodzone.fr</a>


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Pour retrouver la liste de toutes
              <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/events`}>vos inscriptions.</a>
            </p>
            <p className="help-text mt-24">
              C'est ici que vous pouvez consulter la liste de toutes vos inscriptions, passées et à venir. 
              En cliquant sur l'une d'elles, vous accéderez au résumé de la compétition ainsi qu'aux informations 
              personnelles des athlètes de votre équipe, y compris les vôtres.
            </p>
            <p className="help-text mt-24">
              Si vous souhaitez modifier les informations que vous avez renseignées ou même changer d'athlète, 
              consultez<a target='_blank' className="link" href={`/topics/inscription/35`}>l'article</a>dédié pour en savoir plus.
            </p>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicMyInscriptions